module.exports = __webpack_public_path__ + "static/media/main idea.9ec2fbb1.mp3";